/* Album Gallery Store · comportamiento de las secciones personalizadas */
(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }
  function store(get, key, val) {
    try { return get ? localStorage.getItem(key) : localStorage.setItem(key, val); } catch (e) { return null; }
  }

  /* Cuenta atrás de la barra de oferta (fecha fija si hay data-end; si no, se reinicia cada X horas) */
  function initTimers(root) {
    root.querySelectorAll('[data-ags-timer]').forEach(function (el) {
      if (el.__agsInit) return; el.__agsInit = true;
      var hours = parseFloat(el.getAttribute('data-hours')) || 24;
      var key = 'agsPromoEnd' + hours;
      var fixed = Date.parse(el.getAttribute('data-end') || '');
      var end = fixed || parseInt(store(true, key), 10);
      if (!fixed && (!end || end < Date.now())) { end = Date.now() + hours * 3600 * 1000 - 1000; store(false, key, String(end)); }
      var d = el.querySelector('[data-d]'), h = el.querySelector('[data-h]'), m = el.querySelector('[data-m]'), s = el.querySelector('[data-s]');
      function pad(n) { return (n < 10 ? '0' : '') + n; }
      function set(node, n, u) { if (node) node.innerHTML = pad(n) + (u ? '<small>' + u + '</small>' : ''); }
      function tick() {
        var r = Math.max(0, Math.round((end - Date.now()) / 1000));
        if (d) { set(d, Math.floor(r / 86400), 'd'); set(h, Math.floor(r % 86400 / 3600), 'h'); }
        else { set(h, Math.floor(r / 3600), ''); }
        set(m, Math.floor(r % 3600 / 60), d ? 'm' : ''); set(s, r % 60, d ? 's' : '');
        if (r === 0 && !fixed) { end = Date.now() + hours * 3600 * 1000; store(false, key, String(end)); }
      }
      tick(); setInterval(tick, 1000);
    });
    root.querySelectorAll('[data-ags-close]').forEach(function (b) {
      if (b.__agsInit) return; b.__agsInit = true;
      b.addEventListener('click', function () { var t = b.closest('.ags-promo'); if (t) t.hidden = true; });
    });
  }

  /* Carrusel de reseñas */
  function initReviews(root) {
    root.querySelectorAll('[data-ags-reviews]').forEach(function (wrap) {
      if (wrap.__agsInit) return; wrap.__agsInit = true;
      var el = wrap.querySelector('.ags-reviews'), prev = wrap.querySelector('[data-prev]'), next = wrap.querySelector('[data-next]');
      if (!el || !prev || !next) return;
      function step() { var c = el.querySelector('.ags-rev'); var g = parseFloat(getComputedStyle(el).columnGap) || 20; return c ? c.offsetWidth + g : el.clientWidth; }
      function upd() { prev.disabled = el.scrollLeft <= 2; next.disabled = el.scrollLeft + el.clientWidth >= el.scrollWidth - 2; }
      prev.addEventListener('click', function () { el.scrollBy({ left: -step(), behavior: 'smooth' }); });
      next.addEventListener('click', function () { el.scrollBy({ left: step(), behavior: 'smooth' }); });
      el.addEventListener('scroll', upd, { passive: true });
      window.addEventListener('resize', upd);
      upd();
    });
  }

  /* Preguntas frecuentes */
  function initFaq(root) {
    root.querySelectorAll('.ags-fq-q').forEach(function (b) {
      if (b.__agsInit) return; b.__agsInit = true;
      b.addEventListener('click', function () {
        var item = b.closest('.ags-fq'), ans = document.getElementById(b.getAttribute('aria-controls'));
        var open = b.getAttribute('aria-expanded') === 'true';
        b.setAttribute('aria-expanded', String(!open)); item.classList.toggle('open', !open); if (ans) ans.hidden = open;
      });
    });
  }

  function init(root) { initTimers(root); initReviews(root); initFaq(root); }
  ready(function () { init(document); });
  /* Editor de temas: volver a iniciar cuando se recarga una sección */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
